import { Button, Stack, StackProps } from '@mui/material';
import { Body2 } from '@/components/@IntranetLibrary/Typography';
import { useTranslation } from 'react-i18next';
import MsIcon from '@/public/icons/ms.svg';

export type MsAuthRequiredProps = {
  onClick: () => void;
  disabled?: boolean;
} & StackProps;

/**
 * MS 인증이 만료된 위젯에 띄우는 재로그인 안내.
 * 포탈 세션은 살아있으므로 "로그아웃됐다"는 인상을 주지 않도록 문구를 MS 연결에 한정한다.
 */
const MsAuthRequired = (props: MsAuthRequiredProps) => {
  const { t } = useTranslation();
  const { onClick, disabled, ...stackProps } = props;

  return (
    <Stack gap={'12px'} {...stackProps}>
      <Body2
        sx={{
          width: '100%',
          textAlign: 'center',
          padding: '40px 0',
          color: '#B7BBC2',
        }}
      >
        {t('Microsoft 연결이 만료됐어요.')}
        <br />
        {t('다시 로그인하면 이어서 볼 수 있어요.')}
      </Body2>
      <Button
        variant={'outlined'}
        size={'large'}
        onClick={onClick}
        disabled={disabled}
        startIcon={
          <MsIcon
            width="16"
            height="16"
            style={{ opacity: disabled ? '0.3' : 1 }}
          />
        }
      >
        {t('Microsoft로 로그인')}
      </Button>
    </Stack>
  );
};

export default MsAuthRequired;
